import styled from 'vue3-styled-components';

// * 메인 컨텐츠 레이아웃
export const ModalContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 30px;
`;

// * 공단지사 섹션
export const BranchSection = styled.div`
  background: white;
  padding: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const DataSectionTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 3px solid #667eea;
  display: inline-block;
`;

// * 공단지사 관련
export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const RegisterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    background: linear-gradient(135deg, #1a6b7a 0%, #0f4c5c 100%);
  }
`;

export const PatientRegisterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(to right, #3b82f6, #9333ea);
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
  }

  &:disabled {
    background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
`;

export const SearchInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

export const SearchButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
  }
`;

export const SearchResultContainer = styled.div`
  max-height: 400px;
  border: 1px solid #e9ecef;
  overflow-y: auto;
  border-radius: 8px;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 10px;
        margin: 4px 0;
    }

    &::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #cbd5e1, #94a3b8);
        border-radius: 10px;
        border: 2px solid #f1f5f9;
        transition: all 0.2s ease;
        
        &:hover {
        background: linear-gradient(135deg, #94a3b8, #64748b);
        transform: scale(1.05);
        }
        
        &:active {
        background: linear-gradient(135deg, #64748b, #475569);
        }
    }

    &::-webkit-scrollbar-corner {
        background: #f1f5f9;
    }
`;

export const SearchResultItem = styled.div`
  padding: 16px;
  border-bottom: 1px solid #f1f3f5;
  cursor: pointer;

  &:hover {
    background: #f8f9fa;
  }

  &.active {
    background: #e3f2fd;
    border-left: 4px solid #667eea;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const BranchHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const BranchType = styled.span`
  background: #667eea;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
`;

export const BranchName = styled.span`
  font-weight: 600;
  color: #2c3e50;
  flex: 1;
  margin-left: 12px;
`;

export const ActionButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  ${props => props.edit && `
    color: #28a745;
    &:hover { background: #f8fff9; }
  `}
  
  ${props => props.delete && `
    color: #dc3545;
    &:hover { background: #fff5f5; }
  `}
`;

export const BranchAddress = styled.div`
  color: #6c757d;
  font-size: 14px;
  margin-bottom: 4px;
`;

export const BranchPhone = styled.div`
  color: #6c757d;
  font-size: 14px;
`;

export const EmptySearchResult = styled.div`
  padding: 40px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
`;

export const FileListSection = styled.div`
    margin-bottom: 20px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
`;

export const FileListTitle = styled.h3`
    margin: 0 0 15px 0;
    font-size: 16px;
    font-weight: 600;
    color: #495057;
`;

export const FileListContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
`;

export const FileListItem = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background: white;
    border: 2px solid #0f4c5c;
    border-radius: 6px;
    min-width: 200px;
    flex: 1;
`;

export const FileIcon = styled.div`
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    color: #0f4c5c;
    flex-shrink: 0;
`;

export const FileName = styled.span`
    flex: 1;
    font-size: 13px;
    font-weight: 500;
    color: #495057;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const FileStatus = styled.span`
    font-size: 11px;
    font-weight: 500;
    color: #0f4c5c;
    padding: 2px 6px;
    background: #d4edda;
    border-radius: 4px;
    white-space: nowrap;
    flex-shrink: 0;
`;